import { graphql } from '@/gql';
import type { AnnouncementInput } from '@/models/announcement';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateAnnouncement = async ({ id, data }: { id: number; data: AnnouncementInput }) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation UpdateAnnouncement($id: Float!, $data: AnnouncementInputType!) {
        updateAnnouncement(id: $id, data: $data) {
          id
          title
          content
          expiredAt
          repeatedDate
          timeZone
          createdAt
          updatedAt
        }
      }
    `),
    variables: {
      id,
      data,
    },
  });

  return response.data?.updateAnnouncement!;
};
